import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';



export function getComentariosListSuccess(comentarios) {
  return {type: types.LOAD_COMENTARIOS_LIST_SUCCESS, comentarios};
}



export function getComentariosList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ComentariosApi.getComentariosList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(comentarios => {                  
                  dispatch(getComentariosListSuccess(comentarios));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getComentariosSuccess(catalogo) {
  return {type: types.LOAD_COMENTARIOS_SUCCESS, catalogo};
}

export function getComentarios(id,idCurso, token) {
    //console.log(token);
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().ComentariosApi.getComentarios(id,idCurso, token).then(comentarios => {   
        dispatch(getComentariosSuccess(comentarios));
        return comentarios;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(comentarios) {
  return {type: types.SAVE_COMENTARIOS_SUCCESS, comentarios};
}


export function save(comentarios, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ComentariosApi.save(comentarios, token).then(comentariosGuardado => {   
    dispatch(saveSuccess(comentariosGuardado));
        return comentariosGuardado;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function saveComment(comentarios, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ComentariosApi.saveComment(comentarios, token).then(comentariosGuardado => {   
    dispatch(saveSuccess(comentariosGuardado));
        return comentariosGuardado;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function saveImagen(file, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ComentariosApi.saveImagen(file, token).then(imagenGuardado => {
    dispatch(saveSuccess(imagenGuardado));
    return imagenGuardado;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getComentariosComboSuccess(datos) {
  return {type: types.GET_COMENTARIOSS_COMBO_SUCCESS, datos};
}

export function getComentariosCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().ComentariosApi.getComentariosCombo(token).then(datos => {   
        
      dispatch(getComentariosComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(comentarios) {
  return {type: types.BORRAR_COMENTARIOS_SUCCESS, comentarios};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ComentariosApi.borrar(id, token ).then(comentarios => {
                  dispatch(borrarSuccess(comentarios));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}

export function borrarReplySuccess(comentarios) {
  return {type: types.SIN_REDUCER_NECESARIO_SUCCESS, comentarios};
}


export function replyDelete(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ComentariosApi.replyDelete(id, token ).then(comentarios => {
               
                  dispatch(borrarReplySuccess(comentarios));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function activarSuccess(comentarios) {
  return {type: types.ACTIVAR_COMENTARIOS_SUCCESS, comentarios};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ComentariosApi.activar(id, token).then(comentarios => {
               
                  dispatch(activarSuccess(comentarios));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function editarComentarioSuccess(comentarios) {
  return {type: types.SIN_REDUCER_NECESARIO_SUCCESS, comentarios};
}


export function editarComentario(comentario, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ComentariosApi.editarComentario(comentario, token ).then(comentarios => {
               
                  dispatch(editarComentarioSuccess(comentarios));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function editarReplySuccess(reply) {
  return {type: types.SIN_REDUCER_NECESARIO_SUCCESS, reply};
}


export function editarReplay(reply, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ComentariosApi.editarReplay(reply, token ).then(reply => {
               
                  dispatch(editarReplySuccess(reply));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_COMENTARIOS, filtro};
}



